// src/App.tsx
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import './App.css';
import { LOGO_URL } from './constants';
import { inBubbleApp } from './utils/appContext';
import AppLoadingScreen from './components/AppLoadingScreen';

// Lazy-load route components for code splitting
const Dashboard = lazy(() => import('./components/Dashboard'));
const DemoThermostatPage = lazy(() => import('./components/DemoThermostatPage'));
const QRFilterReset = lazy(() => import('./components/QRFilterReset'));
const FilterRecap = lazy(() => import('./components/FilterRecap'));

const PageLoader = () => inBubbleApp ? <AppLoadingScreen /> : (
  <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(to bottom right, #f5f8ef, #e8f0d9)' }}>
    <div className="text-center">
      <img src={LOGO_URL} alt="SmartFilterPro" className="h-16 w-auto mx-auto mb-6" />
      <div className="h-8 w-8 border-4 border-t-transparent rounded-full animate-spin mx-auto mb-4" style={{ borderColor: '#b5c989', borderTopColor: 'transparent' }} />
      <p className="text-gray-600">Loading…</p>
    </div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <NotificationsProvider>
      <Router>
        <div className="App">
          <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Main dashboard - protected route */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            {/* QR Code Filter Reset - protected route for QR scanning */}
            <Route
              path="/filter-reset"
              element={
                <ProtectedRoute>
                  <QRFilterReset />
                </ProtectedRoute>
              }
            />
            {/* Filter Recap - public access (token-based auth) */}
            <Route path="/recap/:token" element={<FilterRecap />} />
            {/* Demo page - public access */}
            <Route path="/demo" element={<DemoThermostatPage />} />
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
        </div>
      </Router>
      </NotificationsProvider>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
